import React from "react";
import Device from "../Device";
import Typography from "@mui/material/Typography";

import { useSelector } from "react-redux";

export default function AllDevicesAccordion({ user }) {
  const currentDevices = useSelector((state) => state.devices.currentDevices);

  return (
    <>
      {currentDevices.length > 0 ? (
        currentDevices.map((device) => (
          <Device key={device.device_id} user={user && user} device={device} />
        ))
      ) : (
        <Typography sx={{ textAlign: "center", flexShrink: 0 }} variant="h5" fontWeight="bold">
          Aucun appareil dans la commande
        </Typography>
      )}
    </>
  );
}
